import React from 'react';
import PropTypes from 'prop-types';

import Icon from 'app/components/common/icon';
import cdn  from 'app/helpers/cdn';

class FileChips extends React.PureComponent {

  render() {
    const {files, className} = this.props;
    if (!files?.length) return null;

    return (
      <div className={`g-files ${className}`}>
        {files.map((file, i) => {
          return (
            <a key={file} className={`g-files-file`} href={cdn.assetUrl(file)} target="_blank">
              <Icon.Attachment1 className="g-files-file-icon" />
              <span className="g-files-file-name">{file.split('/').pop()}</span>
            </a>
          );
        })}
      </div>
    );
  }

}

FileChips.propTypes = {
  files: PropTypes.arrayOf(PropTypes.string),
  className: PropTypes.string,
};

FileChips.defaultProps = {
  className: '',
};

export default FileChips;
